/* PV5 (Oct 16, 2026; v7 Oct 17, preview theme). Gallery counter and arrows, tier-to-variant sync,
   the buy button's label per tier (v7), the gallery's header offset, the sticky bar. No dependencies.
   v7: safe to run again. The theme editor re-renders a section after every setting change and runs
   this file again, so boot() only binds what is new and the page-wide listeners are added once. */
(function () {
  var NS = window.__pv5;
  if (NS && NS.v === 7) { NS.boot(); return; }
  NS = window.__pv5 = { v: 7 };

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initGallery(g) {
    if (g.__pv5) return;
    g.__pv5 = true;
    var track = g.querySelector('[data-pv5-track]');
    if (!track) return;
    var n = track.children.length;
    var count = g.querySelector('[data-pv5-count]');
    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) {
      if (i < 0) i = n - 1;
      if (i >= n) i = 0;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function update() {
      var i = Math.min(n - 1, Math.max(0, index()));
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(n);
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    g.querySelectorAll('[data-pv5-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(index() + parseInt(b.getAttribute('data-pv5-step'), 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      go(index() + (e.key === 'ArrowRight' ? 1 : -1));
    });
    update();
  }

  /* The label is the first text node of the theme's add-to-cart button. A sold-out or disabled
     button keeps the theme's own words. */
  function setLabel(btn, text) {
    if (!btn || btn.disabled || !text) return;
    for (var n = btn.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        if (n.nodeValue !== text) n.nodeValue = text;
        return;
      }
    }
    btn.insertBefore(document.createTextNode(text), btn.querySelector('.add-to-cart__added'));
  }

  function setValue(el, v) {
    if (el.value === v) return;
    el.value = v;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function apply(root) {
    var c = root.querySelector('input[name="pv5-tier"]:checked');
    if (!c) return;
    var productId = root.getAttribute('data-product-id');
    var id = c.getAttribute('data-variant-id');
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      var pid = f.querySelector('[name="product-id"]');
      var field = f.querySelector('[name="id"]');
      if (field && (!pid || pid.value === productId)) setValue(field, id);
    });
    var pay = document.querySelector('[data-pv5-pay]');
    if (pay) {
      pay.textContent = [pay.getAttribute('data-prefix'), c.getAttribute('data-quarter'), pay.getAttribute('data-suffix')]
        .filter(Boolean).join(' ');
    }
    var sn = document.querySelector('[data-pv5-sticky-name]');
    var sp = document.querySelector('[data-pv5-sticky-price]');
    if (sn) sn.textContent = c.getAttribute('data-name');
    if (sp) sp.textContent = c.getAttribute('data-price');
    var label = c.getAttribute('data-cta');
    if (label) {
      document.querySelectorAll('.pv5-product__buy button[name="add"]').forEach(function (b) { setLabel(b, label); });
      var sb = document.querySelector('[data-pv5-sticky-btn]');
      if (sb && sb.textContent !== label) sb.textContent = label;
    }
  }
  function applyAll() { document.querySelectorAll('[data-pv5-tiers]').forEach(apply); }

  function initTiers(root) {
    if (root.__pv5) return;
    root.__pv5 = true;
    root.addEventListener('change', function (e) { if (e.target && e.target.name === 'pv5-tier') apply(root); });
    apply(root);
  }

  /* The header scrolls away with the page, so on the first screen it pushes the full-height
     gallery 53px below the fold. Lift the gallery's counter and arrows by however much header
     is still showing, so they sit on screen from the first frame. */
  function headerOffset() {
    var hdr = document.querySelector('#header-group');
    var gal = document.querySelector('.pv5-product__media');
    if (!hdr || !gal) return;
    var v = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px';
    if (gal.style.getPropertyValue('--pv5-hdr') !== v) gal.style.setProperty('--pv5-hdr', v);
  }

  /* Measured on every scroll frame, not with an observer: a jump from the bottom of the
     page to the top crosses no threshold, and the bar would stay up over the first screen. */
  function sticky() {
    var bar = document.querySelector('[data-pv5-sticky]');
    var buy = document.querySelector('.pv5-product__buy') || document.querySelector('[data-pv5-tiers]');
    if (!bar || !buy) return;
    var cta = document.querySelector('[data-pv5-cta]');
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var past = buy.getBoundingClientRect().bottom < 0;
    var ctaIn = false;
    if (cta) { var r = cta.getBoundingClientRect(); ctaIn = r.top < vh && r.bottom > 0; }
    var next = past && !ctaIn;
    if (bar.classList.contains('is-on') === next) return;
    bar.classList.toggle('is-on', next);
    bar.setAttribute('aria-hidden', next ? 'false' : 'true');
    var b = bar.querySelector('button');
    if (b) b.tabIndex = next ? 0 : -1;
  }

  function render() { headerOffset(); sticky(); }

  function bindGlobal() {
    if (NS.bound) return;
    NS.bound = true;
    document.addEventListener('submit', applyAll, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('button[name="add"]')) applyAll();
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-pv5-sticky-btn]')) return;
      var add = document.querySelector('.pv5-product__buy button[name="add"]') || document.querySelector('button[name="add"]');
      if (add) add.click();
    });
    window.addEventListener('pageshow', applyAll);
    var raf = 0;
    function queue() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; render(); }); }
    window.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue, { passive: true });
  }

  function boot(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll('[data-pv5-gal]').forEach(initGallery);
    root.querySelectorAll('[data-pv5-tiers]').forEach(initTiers);
    bindGlobal();
    render();
  }
  NS.boot = boot;

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();
